import React from "react";
import { Page, ListView, PageHero } from "src/components/common";
import { Button } from "src/components/buttons";
import {
	setStatusCellValue,
	filterByStatus,
	StatusFilterMethod,
} from "src/components/forms/StatusFilter";
import { Tooltip } from "antd";

interface IProps {
	history: any;
	match?: any;
}
const PickListTypeListPage: React.FC<IProps> = (props: IProps) => {
	const columns = [
		{
			Header: <Tooltip title="Code">Code</Tooltip>,
			accessor: "code",
		},
		{
			Header: <Tooltip title="Description">Description</Tooltip>,
			accessor: "description",
		},
		{
			Header: <Tooltip title="Active">Active</Tooltip>,
			accessor: "isActive",
			Cell: setStatusCellValue,
			filterMethod: filterByStatus("isActive"),
			Filter: StatusFilterMethod,
		},
	];

	const editPickListType = (item: PickListType) => {
		props.history.push(`/admin/pick-lists/${item.id}`);
	};

	const navigateToPickList = (item: PickListType) => {
		props.history.push(`/admin/pick-lists/${item.id}/pick-list-items`);
	};

	const getActionLink = (rowId: any): string => {
		return `/admin/pick-lists/${rowId}/pick-list-items`;
	};

	const onRowClick = ({ row }: any) => {
		props.history.push(getActionLink(row._original.id));
	};

	return (
		<Page title="Pick list types">
			<PageHero title="Picklist Items" />
			<div className="container-fluid">
				<div className="d-flex mb-4">
					<Button className="btn-primary ml-auto" to={`/admin/pick-lists/0`}>
						Add PickList Type
					</Button>
				</div>
				<ListView<PickListType>
					filtered={[]}
					collectionName="pick-list-types"
					columnDefinitions={columns}
					onItemEdit={editPickListType}
					onRowClick={onRowClick}
					onItemNavigate={navigateToPickList}
				/>
			</div>
		</Page>
	);
};

export default PickListTypeListPage;
